import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import WebentwicklungHeader from '../components/WebDevelopment/WebentwicklungHeader';
import WebentwicklungKundenseiten from '../components/WebDevelopment/WebentwicklungKundenseiten';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import WebentwicklungEigenschaften from '../components/WebDevelopment/WebentwicklungEigenschaften';
import PageSeo from '../components/Common/PageSeo';
import WebentwicklungEntwickeltMit from '../components/WebDevelopment/WebentwicklungEntwickeltMit';
import WebentwicklungIhrPartnerinderEntwicklung from '../components/WebDevelopment/WebentwicklungIhrPartnerinderEntwicklung';
import WebEntwicklungFAQ from '../components/WebDevelopment/WebentwicklungFAQ';
import WebentwicklungWeitereServices from '../components/WebDevelopment/WebentwicklungWeitereServices';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const WebDevelopment = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';
    return (
        <>
            <PageSeo
                title={t('webDevelopment_page_title')}
                description={t('webDevelopment_page_description')}
                canonical={`${baseUrl}/web-development/`}
                openGraph={{
                    url: `${baseUrl}/web-development/`,
                    title: t('webDevelopment_page_ogTitle'),
                    description: t('webDevelopment_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1080,
                            height: 1080,
                            alt: t('webDevelopment_page_ogImageAlt1'),
                            type: 'image/jpeg',
                        },
                        {
                            url: 'https://simplify-data.de/images/web-development/wordpress_og.png',
                            width: 2000,
                            height: 1080,
                            alt: t('webDevelopment_page_ogImageAlt2'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('webDevelopment_page_title'),
                    locale: 'de_DE',
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('webDevelopment_page_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/web-development/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/web-development/'
                    }
                ]}
            />


            <Navbar />
            <WebentwicklungHeader />
            <WebentwicklungEigenschaften />
            <WebentwicklungKundenseiten />
            <WebentwicklungIhrPartnerinderEntwicklung />
            <WebentwicklungEntwickeltMit />
            <WebEntwicklungFAQ />
            <WebentwicklungWeitereServices />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default WebDevelopment;